import React from 'react';
import { Container } from 'react-bootstrap';

const About = () => (
  <Container className="page mt-lg-4">
    <h1 className="text-center gradient-color-6">About Me</h1>
    <Container className="text-justify text-light mt-md-3">
      <p>
        This page is not really relevant at the moment. For now enjoy this amazing Lorem Ipsum.
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi dignissimos distinctio
        ducimus ea eligendi natus nihil, quaerat repellat sed, sit soluta, temporibus ullam
        voluptatibus! Corporis fuga quisquam recusandae sint veritatis.
      </p>
      <p>
        Adipisci aspernatur atque deleniti esse et fuga hic laboriosam laudantium maiores minima
        officia quas quibusdam quidem recusandae, reprehenderit temporibus ullam? Ad atque dicta
        facere facilis illo molestiae non odit totam.
      </p>
      <p>
        Animi autem consectetur deserunt, dolor, facere fuga hic natus necessitatibus
        obcaecati perferendis praesentium sequi unde! Aliquid corporis culpa delectus earum est
        fugit inventore itaque minima odit repellendus. Est, hic nulla.
      </p>
      <p>
        A ad adipisci aperiam, assumenda aut commodi debitis doloribus eveniet hic illo in, laborum
        natus nemo nostrum nulla numquam officiis optio porro quos ratione repudiandae rerum, sit
        soluta temporibus totam?
      </p>
      <p>
        Consequatur consequuntur cumque doloribus earum esse eveniet excepturi id, illo inventore
        itaque iusto laboriosam natus neque obcaecati perferendis quae quasi qui quibusdam quod
        repellendus sapiente sed sunt vel veritatis vitae!
      </p>
      <p>
        Ad, adipisci commodi corporis delectus deleniti ea enim explicabo fuga fugiat hic laborum
        maxime minima nulla officia officiis optio quo recusandae repellendus similique sunt totam
        velit veniam veritatis vero, voluptate.
      </p>
    </Container>
  </Container>
);

export default About;
